import { call, put, select } from 'redux-saga/effects';

import { setWebhooksEvents } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getWebhookEvents() {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.V2}/applications/webhooks/events`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.GET,
  });

  if (success && !error) {
    yield put(setWebhooksEvents({ events: result }));
  } else {
    console.error(error);
  }
}
